import React from 'react'
import {getLoginRedirectUrl} from '../url'

export const Login = () => {
    window.location.assign(getLoginRedirectUrl());
    return <></>;
};
